"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "WebhookHandlerProcessor", {
    enumerable: true,
    get: function() {
        return WebhookHandlerProcessor;
    }
});
const _common = require("@nestjs/common");
const _webhookHelpers = require("~/helpers/webhookHelpers");
const _models = require("~/models");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let WebhookHandlerProcessor = class WebhookHandlerProcessor {
    async job(job) {
        const { context, hookId, modelId, viewId, prevData, newData, user, hookName, ncSiteUrl } = job.data;
        const hook = await _models.Hook.get(context, hookId);
        if (!hook) {
            this.logger.error(`Hook not found for id: ${hookId}`);
            return;
        }
        const model = await _models.Model.get(context, modelId);
        if (!model) {
            this.logger.error(`Model not found for id: ${modelId}`);
            return;
        }
        const view = viewId ? await _models.View.get(context, viewId) : null;
        await (0, _webhookHelpers.invokeWebhook)(context, {
            hook,
            model,
            view,
            prevData,
            newData,
            user,
            hookName,
            ncSiteUrl,
            addJob: this.jobsService.add.bind(this.jobsService)
        });
    }
    constructor(jobsService){
        this.jobsService = jobsService;
        this.logger = new _common.Logger(WebhookHandlerProcessor.name);
    }
};
WebhookHandlerProcessor = _ts_decorate([
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService
    ])
], WebhookHandlerProcessor);
